exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media (max-width: 1300px) {\n  .style_bitcoinPrice__3mCAo {\n    display: none !important; } }\n", ""]);

// Exports
exports.locals = {
	"bitcoinPrice": "style_bitcoinPrice__3mCAo"
};